import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { syncFormControlDisabledState } from 'common/utils/form-control.util';

@Component({
    selector: 'utc-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CheckboxComponent implements OnChanges {
    @Input() checked: boolean = false;
    @Input() value = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() inputControl: any;
    @Input() disabled ? = false;
    @Input() iconSrc = '';
    @Input() inputId = '';
    @Input() inputName = '';
    @Input() required ? = false;

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes.disabled || changes.inputControl) && this.inputControl) {
            syncFormControlDisabledState(this.inputControl, this.disabled);
        }
    }
}
